<template>
  <v-container fluid class="pa-0">
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t('Sistemos parametrai') }}</h1>

    <v-card outlined class="mb-4" v-if="!loadDefault">
      <v-card-text>
        <v-row>
          <v-col class="pb-0" cols="12" md="12" lg="4">
            <v-simple-table dense>
              <template v-slot:default>
                <tbody>
                  <tr class="n-hov">
                    <td>
                      <strong
                        >{{ $t('Atjungimo nuo sistemos laikas (min)') }}:
                      </strong>
                    </td>
                    <td>
                      <el-text-field
                        style="padding-top: 1.5rem"
                        v-model="formData.logout_time"
                        required
                        validateKey="logout_time"
                        key="logout_time"
                      />
                    </td>
                  </tr>
                  <tr class="n-hov">
                    <td>
                      <strong
                        >{{ $t('Apmokėjimo laikas (dienomis)') }}:
                      </strong>
                    </td>
                    <td>
                      <el-text-field
                        v-model="formData.payment_time"
                        required
                        style="padding-top: 1.5rem"
                        validateKey="payment_time"
                        key="payment_time"
                      />
                    </td>
                  </tr>
                  <tr class="n-hov">
                    <td>
                      <strong
                        >{{ $t('Automatinio išregistravimo laikas') }}:
                      </strong>
                    </td>
                    <td>
                      <el-time-picker
                        style="padding-top: 1.5rem"
                        v-model="formData.deregistration_time"
                        required
                        validateKey="deregistration_time"
                        key="deregistration_time"
                        format="24hr"
                      />
                    </td>
                  </tr>
                  <tr class="n-hov">
                    <td>
                      <strong
                        >{{ $t('ILTU kodo gavimo iš RC ASMENYS') }}:
                      </strong>
                    </td>
                    <td>
                      <el-time-picker
                        style="padding-top: 1.5rem"
                        v-model="formData.check_iltu"
                        required
                        validateKey="check_iltu"
                        key="check_iltu"
                        format="24hr"
                      />
                    </td>
                  </tr>
                  <tr class="n-hov">
                    <td>
                      <strong
                        >{{ $t('Objekto duomenų naikinimo akto sunaikinimo laikas') }}:
                      </strong>
                    </td>
                    <td>
                      <el-time-picker
                        style="padding-top: 1.5rem"
                        v-model="formData.delete_mandates"
                        required
                        validateKey="delete_mandates"
                        key="delete_mandates"
                        format="24hr"
                      />
                    </td>
                  </tr>
                  <tr class="n-hov">
                    <td>
                      <strong
                      >{{ $t('Išrašų paieškų naikinimo ataskaitos sunaikinimo laikas') }}:
                      </strong>
                    </td>
                    <td>
                      <el-time-picker
                        style="padding-top: 1.5rem"
                        v-model="formData.delete_statements"
                        required
                        validateKey="delete_statements"
                        key="delete_statements"
                        format="24hr"
                      />
                    </td>
                  </tr>
                  <tr class="n-hov">
                    <td>
                      <strong
                        >{{ $t('Prisegamo failo dydis') }} (MB):
                      </strong>
                    </td>
                    <td>
                      <el-text-field
                        style="padding-top: 1.5rem"
                        v-model="formData.file_size"
                        required
                        validateKey="file_size"
                        key="file_size"
                        :max="20"
                      />
                    </td>
                  </tr>
                  <tr class="n-hov">
                    <td>
                      <strong
                        >{{ $t('Prisegamo failo tipas') }}:
                      </strong>
                    </td>
                    <td>
                      <el-textarea
                        style="padding-top: 1.5rem"
                        v-model="formData.file_type"
                        required
                        validateKey="file_type"
                        key="file_type"
                      />
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
          <v-col class="pb-0" cols="12" md="12" lg="4">
            <v-simple-table dense>
              <template v-slot:default>
                <tbody>
                  <tr class="n-hov">
                    <td>
                      <strong
                        >{{ $t('Įgaliotojų patvirtinimo laikas (dienomis)') }}:
                      </strong>
                    </td>
                    <td>
                      <el-text-field
                        style="padding-top: 1.5rem"
                        v-model="formData.confirm_time"
                        required
                        validateKey="confirm_time"
                        key="confirm_time"
                      />
                    </td>
                  </tr>
                  <tr class="n-hov">
                    <td>
                      <strong
                        >{{
                          $t(
                            'Naudotojų minimalus amžius išrašams savitarnoje gauti'
                          )
                        }}:
                      </strong>
                    </td>
                    <td>
                      <el-text-field
                        style="padding-top: 1.5rem"
                        v-model="formData.min_age"
                        required
                        validateKey="min_age"
                        key="min_age"
                      />
                    </td>
                  </tr>
                  <tr class="n-hov">
                    <td style="padding-top: 1.5rem; padding-bottom: 1.8rem">
                      <strong
                        >{{
                          $t(
                            'Tikrinti naudotojų neveiksnumą iškarto jiems prisijungus'
                          )
                        }}:
                      </strong>
                    </td>
                    <td>
                      <el-checkbox
                        class="mt-1"
                        label=""
                        v-model="formData.incapacity"
                      >
                      </el-checkbox>
                    </td>
                  </tr>
                  <tr class="n-hov">
                    <td style="padding-top: 1.5rem; padding-bottom: 1.8rem">
                      <strong
                        >{{
                          $t(
                            'Tikrinti asmens neveiksnumą pridedant asmenį į (Prokūrą/Įgaliojimą)'
                          )
                        }}:
                      </strong>
                    </td>
                    <td>
                      <el-checkbox
                        class="mt-1"
                        label=""
                        v-model="formData.incapacity_object"
                      >
                      </el-checkbox>
                    </td>
                  </tr>
                  <tr class="n-hov">
                    <td style="padding-top: 1.5rem; padding-bottom: 1.8rem">
                      <strong
                        >{{
                          $t('Prokūrai automatiškai nustatyti pasirašančius asmenis')
                        }}:
                      </strong>
                    </td>
                    <td>
                      <el-checkbox
                        class="mt-1"
                        label=""
                        v-model="formData.auto_signatures_procuracy"
                      >
                      </el-checkbox>
                    </td>
                  </tr>
                  <tr class="n-hov">
                    <td style="padding-top: 1.5rem; padding-bottom: 1.8rem">
                      <strong
                        >{{
                          $t(
                            'Užklausų žurnalo įrašų saugojimas dienomis. (Suėjus šiam terminui įrašai bus ištrinami negrįžtamai)'
                          )
                        }}:
                      </strong>
                    </td>
                    <td>
                      <el-text-field
                        style="padding-top: 1.5rem"
                        v-model="formData.log_save_time"
                        required
                        validateKey="log_save_time"
                        key="log_save_time"
                      />
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
        <v-row class="pt-4">
          <v-col class="pb-0" cols="12" sm="12" lg="8">
            <v-simple-table dense>
              <template v-slot:default>
                <tbody>
                  <tr class="n-hov">
                    <td class="file-table-title">
                      <div style="margin-top: -1.5rem">
                        <strong
                          >{{ $t('Naudotojų vadovas administratoriui') }}:
                        </strong>
                      </div>
                    </td>
                    <td class="file-table-item">
                      <el-file-input
                        v-model="files.manual_admin"
                        :fileData="formData.manual_admin"
                        :disabled="modeReadonly"
                        @addFile="addFile($event, 'manual_admin')"
                        @clearFile="clearFile($event, 'manual_admin')"
                        validateKey="manual_admin"
                        emitClearFile
                      ></el-file-input>
                    </td>
                  </tr>
                  <tr class="n-hov">
                    <td class="file-table-title">
                      <div style="margin-top: -1.5rem">
                        <strong
                          >{{ $t('Naudotojų vadovas registratoriui') }}:
                        </strong>
                      </div>
                    </td>
                    <td class="file-table-item">
                      <el-file-input
                        v-model="files.manual_registrator"
                        :fileData="formData.manual_registrator"
                        :disabled="modeReadonly"
                        @addFile="addFile($event, 'manual_registrator')"
                        @clearFile="clearFile($event, 'manual_registrator')"
                        validateKey="manual_registrator"
                        emitClearFile
                      ></el-file-input>
                    </td>
                  </tr>
                  <tr class="n-hov">
                    <td class="file-table-title">
                      <div style="margin-top: -1.5rem">
                        <strong
                          >{{ $t('Naudotojų vadovas KAC darbuotojui') }}:
                        </strong>
                      </div>
                    </td>
                    <td class="file-table-item">
                      <el-file-input
                        v-model="files.manual_kac"
                        :fileData="formData.manual_kac"
                        :disabled="modeReadonly"
                        @addFile="addFile($event, 'manual_kac')"
                        @clearFile="clearFile($event, 'manual_kac')"
                        validateKey="manual_kac"
                        emitClearFile
                      ></el-file-input>
                    </td>
                  </tr>
                  <tr class="n-hov">
                    <td class="file-table-title">
                      <div style="margin-top: -1.5rem">
                        <strong
                          >{{ $t('Naudotojų vadovas sutartiniam') }}:
                        </strong>
                      </div>
                    </td>
                    <td class="file-table-item">
                      <el-file-input
                        v-model="files.manual_vasu"
                        :fileData="formData.manual_vasu"
                        :disabled="modeReadonly"
                        @addFile="addFile($event, 'manual_vasu')"
                        @clearFile="clearFile($event, 'manual_vasu')"
                        validateKey="manual_vasu"
                        emitClearFile
                      ></el-file-input>
                    </td>
                  </tr>
                  <tr class="n-hov">
                    <td class="file-table-title">
                      <div style="margin-top: -1.5rem">
                        <strong
                          >{{ $t('Naudotojų vadovas Vieša paieška (LT)') }}:
                        </strong>
                      </div>
                    </td>
                    <td class="file-table-item">
                      <el-file-input
                        v-model="files.manual_public_lt"
                        :fileData="formData.manual_public_lt"
                        :disabled="modeReadonly"
                        @addFile="addFile($event, 'manual_public_lt')"
                        @clearFile="clearFile($event, 'manual_public_lt')"
                        validateKey="manual_public_lt"
                        emitClearFile
                      ></el-file-input>
                    </td>
                  </tr>
                   <tr class="n-hov">
                    <td class="file-table-title">
                      <div style="margin-top: -1.5rem">
                        <strong
                          >{{ $t('Naudotojų vadovas Vieša paieška (EN)') }}:
                        </strong>
                      </div>
                    </td>
                    <td class="file-table-item">
                      <el-file-input
                        v-model="files.manual_public_en"
                        :fileData="formData.manual_public_en"
                        :disabled="modeReadonly"
                        @addFile="addFile($event, 'manual_public_en')"
                        @clearFile="clearFile($event, 'manual_public_en')"
                        validateKey="manual_public_en"
                        emitClearFile
                      ></el-file-input>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-row class="pl-2 py-2" no-gutters>
      <v-spacer></v-spacer>
      <el-button
        v-if="!modeReadonly"
        title="Išsaugoti"
        :loading="loading"
        @click.native="saveData()"
        color="primary"
        icon="išsaugoti"
      />
    </v-row>
  </v-container>
</template>

<script>
import userRole from '@/mixins/userRole'
import upload from '@/mixins/upload'

export default {
  name: 'AdminParameters',
  mixins: [userRole, upload],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      loadDefault: null,
      pageloading: true,
      loading: true,
      formData: {},
      files: {},
      uploadedFiles: {},
      deletedFiles: {},
    }
  },
  created() {
    this.getData()
  },
  computed: {
    modeReadonly() {
      return false
    },
  },
  methods: {
    addFile(file, name) {
      this.addUploadedFiles(file, name)
    },
    clearFile(event, name) {
      delete this.uploadedFiles[name]
      delete this.files[name]
      this.deletedFiles[name] = name
    },
    addUploadedFiles(element, name) {
      if (element != null) {
        delete this.deletedFiles[name]
        this.uploadedFiles[name] = element
      }
    },
    getData() {
      this.loadDefault = null
      this.pageloading = true
      this.loading = true

      this.$axios
        .post(`/system-parameters/list`)
        .then((res) => {
          this.formData = res.data.parameters
        })
        .catch((err) => {
          window._VMA.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.clearErrors()
          this.loading = false
          this.pageloading = false
          this.loadDefault = false
        })
    },

    saveData() {
      if(this.getMaxUploadSize(20)){
        return this.$root.$emit('DATA_ERROR_DIRECT_TEXT', this.getMaxUploadSizeMsg(20))
      }
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.loading = true
          let formData = new FormData()

          Object.keys(this.uploadedFiles).map((key) => {
            formData.append(key, this.uploadedFiles[key])
          })

          Object.keys(this.deletedFiles).map((key) => {
            formData.append('deleteFile[' + key + ']', this.deletedFiles[key])
          })

          formData.append('logout_time', this.formData.logout_time || '')
          formData.append('payment_time', this.formData.payment_time || '')
          formData.append('deregistration_time', this.formData.deregistration_time || '')
          formData.append('check_iltu', this.formData.check_iltu || '')
          formData.append('delete_mandates', this.formData.delete_mandates || '')
          formData.append('delete_statements', this.formData.delete_statements || '')
          formData.append('confirm_time', this.formData.confirm_time || '')
          formData.append('min_age', this.formData.min_age || '')
          formData.append('incapacity', this.formData.incapacity || false)
          formData.append('incapacity_object', this.formData.incapacity_object || false)
          formData.append('file_size', this.formData.file_size || false)
          formData.append('file_types', this.formData.file_types || false)
          formData.append('auto_signatures_procuracy', this.formData.auto_signatures_procuracy || false)

          let url = `system-parameters`
          this.$axios
            .post(url, formData)
            .then((res) => {
              this.$root.$emit('DATA_OK', res.data.message)
              this.getData()
              this.deletedFiles = {};
            })
            .catch((err) => {
              this.$root.$emit('DATA_ERROR', err)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          this.$root.$emit('FORMAT_ERROR')
        }
      })
    },

    clearErrors() {
      this.$nextTick(() => {
        this.errors.clear()
        this.$nextTick(() => {
          this.$validator.reset()
        })
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.file-table-title {
  border-bottom: none !important;
}
.file-table-item {
  border-bottom: none !important;
  width: 75%;
  height: 8rem;
}
</style>
